import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';

import { useAccessMenu } from '@/hooks';

const TargetMap = () => {
  const { t } = useTranslation('page-auth');
  const targetCard = t('targetCard', {}, { returnObjects: true });

  const ImmobilienKaufen = targetCard.filter((item) => item.targetSelect.target === 'ImmobilienKaufen');
  const BauVorhaben = targetCard.filter((item) => item.targetSelect.target === 'BauVorhaben');
  const Modernisierung = targetCard.filter((item) => item.targetSelect.target === 'Modernisierung');
  const Anschlussfinanzierung = targetCard.filter((item) => item.targetSelect.target === 'Anschlussfinanzierung');
  const Immobilienwert = targetCard.filter((item) => item.targetSelect.target === 'Immobilienwert');
  const Projekte = targetCard.filter((item) => item.targetSelect.target === 'Projekte');
  const Dienstleister = targetCard.filter((item) => item.targetSelect.target === 'Dienstleister');
  const KeineAuswahl = targetCard.filter((item) => item.targetSelect.target === 'KeineAuswahl');

  const { data } = useAccessMenu();

  const homeManagement = useMemo(
    () =>
      data?.homemanagement
        ? {
            title: Immobilienwert[0].title,
            image: Immobilienwert[0].image.url,
            alternativeText: Immobilienwert[0].image.alternativeText,
            link: '/dashboard',
            key: 'Immobilienwert',
          }
        : null,
    [Immobilienwert, data?.homemanagement]
  );

  const services = useMemo(
    () =>
      data?.services
        ? {
            title: Dienstleister[0].title,
            image: Dienstleister[0].image.url,
            alternativeText: Dienstleister[0].image.alternativeText,
            link: '/dashboard',
            key: 'Dienstleister',
          }
        : null,
    [Dienstleister, data?.services]
  );

  const projects = useMemo(
    () =>
      data?.projects
        ? {
            title: Projekte[0].title,
            image: Projekte[0].image.url,
            alternativeText: Projekte[0].image.alternativeText,
            link: '/dashboard',
            key: 'Projekte',
          }
        : null,
    [Projekte, data?.projects]
  );

  return {
    targets: [
      {
        title: ImmobilienKaufen[0].title,
        image: ImmobilienKaufen[0].image.url,
        alternativeText: ImmobilienKaufen[0].image.alternativeText,
        link: '/dashboard',
        key: 'ImmobilienKaufen',
      },
      {
        title: BauVorhaben[0].title,
        image: BauVorhaben[0].image.url,
        alternativeText: BauVorhaben[0].image.alternativeText,
        link: '/dashboard',
        key: 'BauVorhaben',
      },
      {
        title: Modernisierung[0].title,
        image: Modernisierung[0].image.url,
        alternativeText: Modernisierung[0].image.alternativeText,
        link: '/dashboard',
        key: 'Modernisierung',
      },
      {
        title: Anschlussfinanzierung[0].title,
        image: Anschlussfinanzierung[0].image.url,
        alternativeText: Anschlussfinanzierung[0].image.alternativeText,
        link: '/dashboard',
        key: 'Anschlussfinanzierung',
      },
      homeManagement,
      projects,
      services,
      {
        title: KeineAuswahl[0].title,
        image: KeineAuswahl[0].image.url,
        alternativeText: KeineAuswahl[0].image.alternativeText,
        link: '/dashboard',
        key: 'KeineAuswahl',
      },
    ].filter(Boolean),
  };
};

export default TargetMap;
